import React, { Component, Fragment } from 'react';

import TextField from '../../artzu-ui/src/TextField';

class Input extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { heading, isInput, value, onChange, error } = this.props;
    return (
      <Fragment>
        <div className="banking-info__section">
          <div className="banking-info__title"> {heading}</div>
          {isInput ? (
            <TextField width="100%" value={value} error={error} onChange={onChange} />
          ) : (
            <div className="banking-info__data"> {value} </div>
          )}
        </div>
      </Fragment>
    );
  }
}
export default Input;



// WEBPACK FOOTER //
// ./src/components/Banking/Input.js